import type React from 'react';

import { useAvailablePeriod } from '@entities/available-periods';
import formatInTimeZone from 'date-fns-tz/formatInTimeZone';
import parseISO from 'date-fns/parseISO';

type Props = {
	id: number;
};

export const AvailablePeriodTime: React.FC<Props> = ({ id }) => {
	const { availablePeriod } = useAvailablePeriod(id);

	return (
		<>
			{availablePeriod &&
				formatInTimeZone(parseISO(availablePeriod.start_time), 'Europe/Moscow', 'HH:mm (zzz)')}
		</>
	);
};
